<template>
  <ValidationObserver ref="form" v-slot="{ invalid: invalidForm, errors }">
    <!-- 휴대폰 번호 입력 시작 -->
    <ValidationObserver ref="phoneForm" v-slot="{ invalid }">
      <form @submit.prevent="$emit('requestCode', form.phone)">
        <ValidationProvider
          v-slot="{ errors }"
          name="phone"
          rules="required|phone"
          tag="div"
          class="input-box mb-1"
        >
          <p>휴대폰 번호</p>
          <v-layout>
            <v-text-field
              v-model="form.phone"
              outlined
              dense
              autofocus
              type="tel"
              hide-details
              ref="inputPhone"
              placeholder="예) 01012345678"
              :error="errors.length > 0"
              :disabled="request.success"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
            >
              <template v-slot:append>
                <v-fade-transition>
                  <img
                    v-if="form.phone && !request.success"
                    src="@/assets/images/icons/clear.svg"
                    @click="form.phone = ''"
                  />
                </v-fade-transition>
              </template>
            </v-text-field>

            <v-btn
              depressed
              :class="request.success && !confirm.success ? 'white--inset' : 'btn--gray-100'"
              :disabled="
                invalid || !precondition || request.loading || confirm.loading || confirm.success
              "
              type="submit"
            >
              {{ request.success ? '다시 요청' : '인증 요청' }}
            </v-btn>
          </v-layout>
        </ValidationProvider>
      </form>
    </ValidationObserver>
    <!-- 휴대폰 번호 입력 끝 -->

    <!-- 인증 번호 입력 시작 -->
    <v-scroll-y-transition>
      <ValidationObserver ref="codeForm" v-slot="{ invalid }">
        <form @submit.prevent="$emit('confirmCode', form.code)">
          <ValidationProvider
            v-if="request.success"
            v-slot="{ errors }"
            name="verify"
            rules="required|digits:6"
            tag="div"
            class="input-box mt-1 mb-0"
          >
            <v-layout>
              <v-text-field
                v-model="form.code"
                outlined
                dense
                autofocus
                type="tel"
                hide-details
                ref="inputCode"
                placeholder="예) 000000"
                :error="errors.length > 0"
                autocomplete="one-time-code"
                :disabled="confirm.loading || confirm.success"
                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').substring(0,6)"
              >
                <template v-slot:append>
                  <Timer
                    v-if="!confirm.success"
                    class="timer"
                    :expireTime="$moment(confirm.form.expirationTime)"
                    @timeOut="$emit('expire')"
                  />
                </template>
              </v-text-field>
              <v-btn
                depressed
                class="btn--gray-100"
                :disabled="
                  invalid ||
                  request.loading ||
                  confirm.expired ||
                  confirm.loading ||
                  confirm.success
                "
                type="submit"
              >
                {{ confirm.success ? '인증 완료' : '인증 하기' }}
              </v-btn>
            </v-layout>
          </ValidationProvider>
        </form>
      </ValidationObserver>
    </v-scroll-y-transition>
    <!-- 인증 번호 입력 끝 -->

    <!-- 폼 에러 메세지 시작 -->
    <v-scroll-y-reverse-transition group>
      <p v-if="invalidForm && errors.phone.length > 0" key="phoneError" class="color--pinkred-110">
        {{ errors.phone[0] }}
      </p>
      <p
        v-else-if="invalidForm && errors.verify && errors.verify.length > 0"
        key="verifyError"
        class="color--pinkred-110"
      >
        {{ errors.verify[0] }}
      </p>
    </v-scroll-y-reverse-transition>
    <!-- 폼 에러 메세지 끝 -->
  </ValidationObserver>
</template>

<script>
import Timer from './Timer.vue'

export default {
  components: { Timer },
  props: {
    precondition: {
      type: Boolean,
      default: true,
    },
    request: {
      type: Object,
      required: true,
    },
    confirm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        phone: '',
        code: '',
      },
      errorMsg: null,
    }
  },
  methods: {
    clearCode() {
      this.form.code = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.timer {
  color: $pinkred-110;
  position: absolute;
  right: 16px;
  margin-top: 5px;
  font-weight: bold !important;
  background-color: white;
  padding-left: 5px;
}
</style>
